import { fetchOrders, getBill } from '../../../api/bill'
import { payLc } from '../../../api/orders'

// initial state
const state = {
  orders: [],
  profileId: '',
  orderId: '',
  loading: false,
  error: ''
}

// getters
const getters = {
  orders: state => state.orders,
  profileId: state => state.profileId,
  orderId: state => state.orderId,
  loading: state => state.loading,
  error: state => state.error
}

// actions
const actions = {
  async fetchOrders ({commit, state}) {
    commit('setLoading', true)
    const data = await fetchOrders()
    commit('setOrders', {orders: data.orders})
    commit('setLoading', false)
  },
  async payLc ({commit, state}, {orderId}) {
    commit('setLoading', true)
    try {
      await payLc({orderId})
    } catch (e) {
      commit('setError', {error: e.response.data.error})
    }
    commit('setLoading', false)
  },
  async getBill ({commit, state, dispatch}) {
    commit('setError', {error: ''})
    commit('setLoading', true)
    try {
      let res = await getBill({
        orderId: state.orderId,
        profileId: state.profileId
      })
      window.location.href = '/personal/service/report.php?ORDER_ID=' + res.id
    } catch (e) {
      commit('setError', {error: e.response.data.error})
    } finally {
      commit('setLoading', false)
      dispatch('fetchOrders')
    }
  }
}

// mutations
const mutations = {
  setOrders (state, {orders}) {
    state.orders = orders
  },
  setProfileId (state, {profileId}) {
    state.profileId = profileId
  },
  setOrderId (state, {orderId}) {
    state.orderId = orderId
  },
  setError (state, {error}) {
    state.error = error
  },
  setLoading (state, loading) {
    state.loading = loading
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/components/store/modules/bill.js